module.exports = "/assets/_next/static/images/avatar-watermark-small-9fc7761346c0ec1d53ff8ed1f4b160c6.png";